<template>
  <div class="w-full justify-center flex">
    <div
      @click="this.$router.go()"
      class="w-full flex justify-start h-20 top-0 pl-4 md:pl-10 pt-8 fixed bg-white z-10 cursor-pointer"
    >
      <logo-icon />
    </div>
    <div>
      <div
        class="w-full mt-6 md:pt-4 flex justify-center item-center mx-2 md:w-441px"
      >
        <o-card class="w-full mx-2">
          <div class="md:p-4 text-black-2">
            <span class="flex justify-center font-bold text-xl">
              Authentication
            </span>
            <div>
              <div class="my-4">
                <span class="font-semibold"> Step 1:</span> Get the
                <span class="font-semibold">Authenticator App </span> from the
                <span class="font-semibold">App Store or Play Store </span>
              </div>
              <div class="my-3">
                <span class="font-semibold"> Step 2:</span> In the App select
                <span class="font-semibold"> Set up account.</span>
              </div>
              <div class="my-3">
                <span class="font-semibold"> Step 3:</span> Choose
                <span class="font-semibold"> Scan a barcode.</span>
              </div>
              <div class="my-3">
                <span class="font-semibold"> Step 4:</span> Enter the
                <span class="font-semibold">verification code </span> shown in
                the authentificator app
              </div>
            </div>

            <div class="flex justify-center my-4">
              <img
                class="inline"
                v-bind:src="'data:image/jpeg;base64,' + img"
              />
            </div>
            <span
              class="text-grey-8 font-semibold flex justify-center text-sm my-4"
            >
              Enter 6 digit code</span
            >
            <div class="mx-4">
              <el-form
                label-position="top"
                :model="authForm"
                ref="authForm"
                :rules="rules"
                label-width="80px"
                size="normal"
                @submit.prevent
                @keyup.enter.native="verifyAuthSetUp('authForm')"
              >
                <el-form-item prop="code">
                  <el-input
                    name="code"
                    class="text-xl"
                    v-model="authForm.code"
                    placeholder="******"
                    maxlength="6"
                  ></el-input>
                </el-form-item>
                <el-form-item class="mb-4 hidden">
                  <el-input
                    class="text-xl"
                    v-model="test"
                    name="test"
                    placeholder="hidden"
                  ></el-input>
                </el-form-item>
                <el-form-item class="mt-6">
                  <o-button
                    @click="verifyAuthSetUp('authForm')"
                    :loading="isLoading"
                    >{{ isLoading ? 'Confirming....' : 'Confirm' }}</o-button
                  >
                </el-form-item>
                <p
                  class="flex justify-center text-lg md:text-normal mt-5 cursor-pointer"
                  @click="handleClose"
                >
                  cancel
                </p>
              </el-form>
            </div>
          </div>
        </o-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'authenticationSetUp',
  data () {
    return {
      img: '',
      test: '',
      isLoading: false,
      rules: {
        code: [
          {
            required: true,
            message: 'Please input a valid pin',
            trigger: ['blur', 'change']
          }
        ]
      },
      authForm: {
        code: ''
      }
    }
  },
  methods: {
    handleClose () {
      this.$router.go()
    },
    verifyAuthSetUp (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.complete2fa()
        } else {
          this.$notify.error({
            title: 'Invalid Pin',
            message: 'please input a valid pin',
            position: 'top-right'
          })
        }
      })
    },
    initiate2Fa () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/initiate2fa', this.authDetails.userID)
        .then((res) => {
          this.img = res.data.data.qrCode
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: 'oops',
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    complete2fa () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/complete2fa', {
          ...this.authForm,
          userID: this.authDetails.userID
        })
        .then((res) => {
          vm.$message({
            showClose: true,
            message: '2fa completed successfully',
            type: 'secondary'
          })
          this.$emit('completed2fa')
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  computed: {
    authDetails () {
      return this.$store.state.auth.authDetails
    }
  },
  watch: {
    'authForm.code': function (newValue) {
      if (newValue.length !== 6) {
        const result = newValue.replace(/\D/g, '').replace(/[^0-9]/g, '')
        this.$nextTick(() => {
          this.authForm.code = `${result}`
        })
      } else {
        this.complete2fa()
      }
    },
    deep: true
  },
  mounted () {
    this.initiate2Fa()
  }
}
</script>

<style scoped>
>>> .el-input__inner {
  border-radius: 8px;
  letter-spacing: 20px;
  padding-right: 3px;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  border-color: #c7c8d2;
  height: 48px;
}
</style>
